import React from 'react';

const VARIANT_STYLES = {
  primary: {
    backgroundColor: '#007fff',
    color: '#fff',
  },
  secondary: {
    backgroundColor: '#161819',
    color: '#fff',
  },
  danger: {
    backgroundColor: '#dc3545',
    color: '#fff',
  },
};

const Button = ({
  text,
  onClick,
  type = 'button',
  disabled = false,
  variant = 'primary',
  loading = false, // show loading spinner
  style = {},
}) => {
  // use secondary color if disabled
  const variantStyle = disabled
    ? VARIANT_STYLES.secondary
    : VARIANT_STYLES[variant] || VARIANT_STYLES.primary;

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading} // also disable while loading
      style={{
        width: '100%',
        height: '100%',
        padding: '10px 10px',
        border: 'none',
        borderRadius: '4px',
        cursor: disabled ? 'not-allowed' : 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        ...variantStyle,
        ...style,
      }}
    >
      {loading && (
        <span
          className="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        />
      )}
      <span className="fw-bold">{text}</span>
    </button>
  );
};

export default Button;
